<template>
  <div class="car-conversation-item-container">
    <div class="car-conversation-item">
      <div class="car-subheadline">
        {{ $t('conversation.attachedFileTitle') }}
      </div>
      <div class="">
        {{ item.name }}
      </div>
      <a class="car-btn" target="_blank" :href="fileUrl">
        {{ $t('conversation.attachedFileDownloadBtn') }}
      </a>
    </div>
  </div>
</template>

<script>
import storageApiService from '@/services/storageApiService';

export default {
  name: 'ConversationFileItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    downloadFile() {
      storageApiService.downloadFile(this.item.id)
        .then(res => {
          let blob = new Blob([res.data]);
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.click();
        })
    }
  },
  computed: {
    fileUrl() {
      return `${this.$SMP_CONFIG.hostConfig.apiProtocols}://${this.$SMP_CONFIG.hostConfig.apiHost}/fileserver/resource/${this.item.id}/content`;
    }
  }
}
</script>
